import { Merge } from 'type-fest'

import { DipsSchemas } from '~/clients/dips-client'

export type DipsWard = DipsSchemas['WardDto']
export type UnifiedDipsWard = Merge<{ entity_type: 'dips_ward' }, DipsWard>

export function transformDipsWards(wards: DipsWard[]): UnifiedDipsWard[] {
    return wards.map(ward => ({
        ...ward,
        entity_type: 'dips_ward',
    }))
}
